import { evaluate } from '/webpack/assets/js/triggerConditions.js';

$(document).ready(function () {
	'use strict';

	// TODO DEVDVG-800 - pokud je při inicializaci formu selectbox/radio list nebo checkbox list označen jako error kvůli nevalidne vybranné option tak musí zůstat označené chybou!!!

	const optionRules = {};
	const selectOptionList = {};

	const resolveCondition = function (condition) {
		return {
			$trigger: $(`[data-control-name="${condition.triggerName}"]`),
			expectedValue: condition.triggerOption,
		};
	};

	$('[data-option-rules]').each(function () {
		const $optionRulesHolder = $(this);
		const dataOptionRules = $(this).data('option-rules');

		$optionRulesHolder.find('select').each(function () {
			const targetControl = $(this);
			const selectId = targetControl.attr('id');

			if (!selectOptionList[selectId]) {
				selectOptionList[selectId] = [];
			}

			targetControl.find(`option`).each(function () {
				const $option = $(this);
				const $optgroup = $option.parent('optgroup');

				selectOptionList[selectId].push({
					option: $option,
					originalParent: $optgroup.length ? $optgroup : targetControl,
				});
			});
		});

		$.each(dataOptionRules, function (targetOption, ruleList) {
			for (const conditionList of ruleList) {
				for (const condition of conditionList) {
					const triggerName = condition['triggerName'];
					const triggerOption = condition['triggerOption'];

					if (!optionRules[triggerName]) {
						optionRules[triggerName] = [];
					}

					optionRules[triggerName].push({
						targetControl:       $optionRulesHolder.find(`select, input[value="${targetOption}"]`),
						targetOptionControl: $optionRulesHolder.find(`option[value="${targetOption}"], input[value="${targetOption}"]`),
						targetOption,
						triggerOption,
						ruleList,
					});
				}
			}
		});
	});

	$.each(optionRules, function (triggerName) {
		$(`[data-control-name="${triggerName}"]`).on('change', function () {
			const $triggerControl = $(this);
			const $form = $triggerControl.parents('form');
			const targetControlIdList = [];

			if ($triggerControl.is('[data-check-is-filled]')) {
				const $requiredFile = $triggerControl.parents('smart-input').find('input[type=checkbox][data-check-is-required]');
				const required = $triggerControl.hasClass('error');

				if ($requiredFile.prop('checked') !== required) {
					$requiredFile.prop('checked', required).trigger('change');
				}
			}

			$.each(optionRules[triggerName], function (index, item) {
				const targetTagName = item.targetControl.prop('tagName');
				const targetType = item.targetControl.attr('type');
				// Deselect must follow the same evaluation as visibility — a value left on a
				// hidden option would otherwise survive, and a still-displayed option (other
				// OR-ed rule) would be wrongly cleared.
				const shouldBeDisplayed = evaluate(item.ruleList, resolveCondition);

				if (shouldBeDisplayed === false) {
					// Checkbox / Radio button
					if (targetTagName === 'INPUT' && (targetType === 'checkbox' || targetType === 'radio') && item.targetControl.prop('checked') === true) {
						item.targetControl.prop('checked', false).trigger('change');
					}
					// Select box
					else if (item.targetOption === item.targetControl.val() && item.targetControl.val() !== "") {
						item.targetControl.val("").trigger('change');
					}
				}

				// enable / disable option
				item.targetOptionControl.attr('disabled', shouldBeDisplayed === false);
				item.targetOptionControl.attr('hidden', shouldBeDisplayed === false);

				if (targetTagName === 'SELECT' && targetControlIdList.indexOf(item.targetControl.attr('id')) === -1) {
					targetControlIdList.push(item.targetControl.attr('id'));
				}
			});

			$.each(targetControlIdList, function (targetIndex, targetControlId) {
				const $targetControl = $(`#${targetControlId}`);
				const targetControlElement = $targetControl[0];

				$.each(selectOptionList[targetControlId], function (optionIndex, item) {
					if (item.option.prop('disabled') === true && item.option.val() === "") {
						return;
					}

					if (item.option.prop('disabled') === true) {
						item.option.detach().attr('selected', false);
					}
					else {
						item.originalParent.append(item.option);
						item.option.attr('hidden', false);
					}

					if (item.originalParent.prop('tagName') === 'OPTGROUP') {
						if (item.originalParent.children().length === 0) {
							item.originalParent.detach();
						}
						else {
							$targetControl.append(item.originalParent);
						}
					}
				});

				if (targetControlElement && targetControlElement.tomselect) {

					targetControlElement.tomselect.clearOptions();
					targetControlElement.tomselect.sync();
					targetControlElement.tomselect.refreshOptions(false);

					if ($targetControl.val() === "" || $targetControl.val() === null) {
						targetControlElement.tomselect.clear(true);
					}
				}
			});

			// Refresh nette toggle triggers
			Nette.toggleForm($form[0]);
		}).trigger('change');
	});
});
